import React, { useEffect } from 'react';

export default function NoAutocompleteProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const setNoAutocomplete = () => {
      const elements = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>(
        'input, textarea, select'
      );

      elements.forEach((el, index) => {
        if (!el.dataset.noautocomplete) {
          const tag = el.tagName.toLowerCase();

          if (tag === 'input' && (el as HTMLInputElement).type === 'password') {
            el.setAttribute('autocomplete', 'new-password');
            el.setAttribute('name', `pwd-${index}-${Date.now()}`);
            el.setAttribute('id', `pwd-${index}-${Date.now()}`);

            el.setAttribute('readonly', 'true');
            el.addEventListener('focus', () => {
              el.removeAttribute('readonly');
            }, { once: true });
          }
          else {
            el.setAttribute('autocomplete', 'nope');
            el.setAttribute('name', `field-${index}-${Date.now()}`);
          }

          el.dataset.noautocomplete = 'true';
        }
      });
    };

    setNoAutocomplete();

    const observer = new MutationObserver(() => setNoAutocomplete());
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return <>{children}</>;
}
